import * as XLSX from "xlsx-js-style";

export const TimesheetReportExcel = (
  data = [],
  filters = {},
  projectName = "",
  managerName = ""
) => {
  if (!Array.isArray(data) || data.length === 0) return;

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([]);

  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  /* ================= TITLE (A1) ================= */
  const title = `Timesheet - ${filters.EmployeeID || ""} (${monthNames[filters.Month - 1]} - ${filters.Year})`;

  XLSX.utils.sheet_add_aoa(ws, [[title]], { origin: "A1" });

  ws["A1"].s = {
    font: { bold: true, sz: 16 },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "BDD7EE" } }
  };

  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];
  ws["!rows"] = [{ hpt: 30 }];

  /* ================= HEADER DETAILS (A3–A5) ================= */
  const headerDetails = [
    [`Project: ${projectName || ""}`],
    [`Manager: ${managerName || ""}`],
    ["Comp → Completed || Appr → Approved"],
  ];

  XLSX.utils.sheet_add_aoa(ws, headerDetails, { origin: "A3" });

  ws["!merges"].push(
    { s: { r: 2, c: 0 }, e: { r: 2, c: 7 } }, // A3
    { s: { r: 3, c: 0 }, e: { r: 3, c: 7 } }, // A4
    { s: { r: 4, c: 0 }, e: { r: 4, c: 7 } }  // A5
  );

  ["A3", "A4", "A5"].forEach(cell => {
    ws[cell].s = { font: { bold: true } };
  });

  /* ================= TABLE HEADER (A7) ================= */
  const tableHeader = [
    ["SL#", "Date", "Project", "Task", "Hrs", "Comp Date", "Appr By", "Appr Date"]
  ];

  XLSX.utils.sheet_add_aoa(ws, tableHeader, { origin: "A7" });

  const tableHeaderStyle = {
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  for (let C = 0; C < 8; C++) {
    const cell = XLSX.utils.encode_cell({ r: 6, c: C }); // A7
    ws[cell].s = tableHeaderStyle;
  }

  /* ================= TABLE DATA (A8+) ================= */
  const tableData = data.map((row, index) => ([
    index + 1,
    row.DTDate || "",
    row.ProjectCode || "",
    [row.Description?.trim(), row.Comments?.trim()]
      .filter(Boolean)
      .join(" || "),
    row.ActualHourse || "",
    row.CompletedDate?.split(" ")[0] || "",
    row.ManagerCode || "--",
    row.ApprovedDate || "",
  ]));

  XLSX.utils.sheet_add_aoa(ws, tableData, { origin: "A8" });

  /* ================= ROW STYLES ================= */
  const range = XLSX.utils.decode_range(ws["!ref"]);

  const oddRowStyle = {
    fill: { fgColor: { rgb: "FFFFFF" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const evenRowStyle = {
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  for (let R = 7; R <= range.e.r; R++) { // A8 onward
    const baseStyle = R % 2 === 0 ? evenRowStyle : oddRowStyle;

    for (let C = 0; C < 8; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell]) continue;

      ws[cell].s = {
        ...baseStyle,
        alignment: {
          horizontal: C === 0 || C === 4 ? "center" : "left",
          vertical: "center",
          wrapText: true
        }
      };
    }
  }

  /* ================= COLUMN WIDTH ================= */
  ws["!cols"] = [
    { wch: 6 },   // SL#
    { wch: 12 },  // Date
    { wch: 12 },  // Project
    { wch: 92 },  // Task
    { wch: 8 },   // Hrs
    { wch: 12 },  // Comp Date
    { wch: 14 },  // Appr By
    { wch: 14 },  // Appr Date
  ];

  /* ================= EXPORT ================= */
  XLSX.utils.book_append_sheet(wb, ws, "Timesheet_Report");
  XLSX.writeFile(
    wb,
    `Timesheet_${monthNames[filters.Month - 1]}_${filters.Year}.xlsx`
  );
};

export default TimesheetReportExcel;